export const SORT_KEY = 'sort';
export const ORDER_KEY = 'order';
export const PAGE_SIZE_KEY = 'sz';
export const PAGE_KEY = 'page';
export const FROM_KEY = 'from';
export const TO_KEY = 'to';
export const DEFAULT_CURRENCY = 'usd';
